/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocumentUploadIndexRouteImport } from './routes/document-upload/index'
import { Route as SignupSplatRouteImport } from './routes/signup/$'
import { Route as SigninSplatRouteImport } from './routes/signin/$'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentUploadIndexRoute = DocumentUploadIndexRouteImport.update({
  id: '/document-upload/',
  path: '/document-upload/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupSplatRoute = SignupSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SignupRoute,
} as any)
const SigninSplatRoute = SigninSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SigninRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/signin': typeof SigninRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/signin/$': typeof SigninSplatRoute
  '/signup/$': typeof SignupSplatRoute
  '/document-upload': typeof DocumentUploadIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signin': typeof SigninRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/signin/$': typeof SigninSplatRoute
  '/signup/$': typeof SignupSplatRoute
  '/document-upload': typeof DocumentUploadIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/signin': typeof SigninRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/signin/$': typeof SigninSplatRoute
  '/signup/$': typeof SignupSplatRoute
  '/document-upload/': typeof DocumentUploadIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/signup'
    | '/signin/$'
    | '/signup/$'
    | '/document-upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/signup'
    | '/signin/$'
    | '/signup/$'
    | '/document-upload'
  id:
    | '__root__'
    | '/'
    | '/signin'
    | '/signup'
    | '/signin/$'
    | '/signup/$'
    | '/document-upload/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SigninRoute: typeof SigninRouteWithChildren
  SignupRoute: typeof SignupRouteWithChildren
  DocumentUploadIndexRoute: typeof DocumentUploadIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-upload/': {
      id: '/document-upload/'
      path: '/document-upload'
      fullPath: '/document-upload'
      preLoaderRoute: typeof DocumentUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/$': {
      id: '/signup/$'
      path: '/$'
      fullPath: '/signup/$'
      preLoaderRoute: typeof SignupSplatRouteImport
      parentRoute: typeof SignupRoute
    }
    '/signin/$': {
      id: '/signin/$'
      path: '/$'
      fullPath: '/signin/$'
      preLoaderRoute: typeof SigninSplatRouteImport
      parentRoute: typeof SigninRoute
    }
  }
}

interface SigninRouteChildren {
  SigninSplatRoute: typeof SigninSplatRoute
}

const SigninRouteChildren: SigninRouteChildren = {
  SigninSplatRoute: SigninSplatRoute,
}

const SigninRouteWithChildren =
  SigninRoute._addFileChildren(SigninRouteChildren)

interface SignupRouteChildren {
  SignupSplatRoute: typeof SignupSplatRoute
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupSplatRoute: SignupSplatRoute,
}

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SigninRoute: SigninRouteWithChildren,
  SignupRoute: SignupRouteWithChildren,
  DocumentUploadIndexRoute: DocumentUploadIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
